import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../../services';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    public authService: AuthService, 
    public router: Router
  ) {}
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const expectedPermissions = next.data.permissions;

    if(!expectedPermissions || (expectedPermissions && this.authService.hasPermission(expectedPermissions))) {
      return true;
    }

    this.router.navigate(['/nothing-here']);
    return false;
  }
}
